/* eslint-disable prettier/prettier */
import { useState, useRef, useEffect } from 'react';
import { MoreVertical, Ban, User, Eye } from 'lucide-react';

export const UserRow = ({ user, onView, onToggleStatus, isSuperAdmin, currentUserId }: any) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement | null>(null);
  const buttonRef = useRef<HTMLButtonElement | null>(null);
  const formatRoleName = (roleName: string) => {
  if (!roleName) return '';
  return roleName
    .trim()
    .replace(/_/g, ' ')
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node) &&
        buttonRef.current &&
        !buttonRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const canToggleStatus =
    (isSuperAdmin && user.role?.name === 'SUPER_ADMIN' && user.id !== currentUserId) ||
    (!isSuperAdmin && user.id !== currentUserId);

  return (
    <div className="cursor-pointer sm:w-[90%] flex items-center px-4 py-3 bg-white border-b border-x hover:bg-light">
      <div
        className={`${isSuperAdmin ? 'w-[30%]' : 'w-[40%]'} flex items-center gap-3 text-primary font-medium`}
      >
        {user.profilePic ? (
          <img
            src={`${process.env.REACT_APP_API_BASE_URL}${user.profilePic}`}
            alt="profile picture"
            className="hidden transform scale-110 rounded-full w-9 h-9 sm:block"
          />
        ) : (
          <div className="items-center justify-center hidden rounded-full w-9 h-9 sm:flex bg-muted text-muted-foreground">
            <User className="w-5 h-5 text-primary" />
          </div>
        )}
        <div className="flex flex-col">
          <span className="text-sm font-semibold text-primary">{user.username}</span>
          <span className="text-xs text-muted-foreground">{user.email}</span>
        </div>
      </div>

      {isSuperAdmin && (
        <div className="w-[25%] text-muted-foreground">{user.company?.name || ''}</div>
      )}

      <div className={`${isSuperAdmin ? 'w-[20%]' : 'w-[30%]'}  text-muted-foreground`}>
        {user.role?.name ? formatRoleName(user.role.name) : ''}
      </div>

      <div className={`${isSuperAdmin ? 'w-[20%]' : 'w-[30%]'} `}>
        <span
          className={`px-2 py-1 text-sm rounded-full ${
            user.isActive ? 'bg-green-100 text-green-600' : 'bg-red-100 text-red-600'
          }`}
        >
          {user.isActive ? 'Active' : 'Inactive'}
        </span>
      </div>

      <div className={`${isSuperAdmin ? 'w-[5%]' : 'w-[5%]'} flex justify-end relative`}>
        <button ref={buttonRef} onClick={() => setIsOpen(!isOpen)}>
          <MoreVertical className="w-5 h-5 text-muted-foreground" />
        </button>
        {isOpen && (
          <div
            ref={dropdownRef}
            className="absolute right-0 z-10 w-40 mt-2 bg-white border rounded shadow-md"
          >
            <button
              onClick={onView}
              className="flex items-center w-full gap-2 px-4 py-2 text-sm hover:bg-highlight"
            >
              <Eye className="w-4 h-4" /> View
            </button>

            {canToggleStatus && (
              <button
                onClick={onToggleStatus}
                className="flex items-center w-full gap-2 px-4 py-2 text-sm text-red-600 hover:bg-highlight"
              >
                <Ban className="w-4 h-4" /> {user.isActive ? 'Disable' : 'Enable'}
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};
